export default __webpack_public_path__ + "static/media/yogatimeFacebook-1200x630.105576ef.jpg";